// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"8dc2a4d5","104":"1638e80b"}[chunkId] + ".chunk.js";
};